module.exports = __webpack_public_path__ + "media/images/img-pet-7-0b251b9c.jpg";